import { esBodasPalettes } from "../../../../Posts/05-tematicas/07-bodas/bodasPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esBodasPalettes,
  localizeTematicPalettes,
  React
};